export const tasksTagsViewRoutesName = {
    tasksTagsView: "tasks-tags-view",
};
